import request from './httpService';

export const AuthService = {
  login: (email, password) => request({ url: '/auth/login', method: 'POST', suppressAuthError: true, data: { email, password } }),
  logout: () => request({ url: '/auth/logout', method: 'POST' }),
  me: (opts = {}) => request({ url: '/auth/me', method: 'GET', suppressAuthError: true, ...opts }),
  csrf: () => request({ url: '/auth/csrf', method: 'GET' }),
  permissions: () => request({ url: '/auth/permissions', method: 'GET' }),
  refreshPermissionsCache: (scope = 'role') => request({ url: '/auth/permissions/refresh', method: 'POST', data: { scope } }),
  changePassword: (currentPassword, newPassword) => request({ url: '/auth/change-password', method: 'POST', data: { currentPassword, newPassword } })
};
